import { inject, Injectable } from "@angular/core";
import { PersistenceService } from "./persistence.service";
import { IdleUserService } from "./idle-user.service";

@Injectable({ providedIn: 'root' })
export class AppInitializer {
    private persistenceService = inject(PersistenceService);
    private idelUserService = inject(IdleUserService);
    initializeAuth(): Promise<void> {
        return new Promise((resolve) => {
            this.persistenceService.init(this.idelUserService.shouldUserBeLoggedOutOnPageLoad());
            resolve();
        });

    }
}